//@flow
import React from 'react';
import s from './LinePercentScale.less';
import {percentOfTotalNotFixed} from '../../../helpers';
import getProperty from 'lodash.get';

type Props = {
  totalFobTooling: number,
  data: Object,
};

const LinePercentScale = ({totalFobTooling, data}: Props) => {
  const sectionToolingCost = getProperty (
    data,
    ['Tooling Cost', 'sectionSummary', 'cost'],
    0
  );
  const otherAdjCost = getProperty (
    data,
    ['Other Cost', 'sectionSummary', 'cost'],
    0
  );

  const totalFobwithoutTooling = totalFobTooling - sectionToolingCost;

  //The FOB percentage scale section needs to end at the beginning of the Other Adjustment cost bar if it is negative.
  //This gets the correct width percentage for the percentage scale.
  const scaleWidth = otherAdjCost >= 0
    ? percentOfTotalNotFixed (
        sectionToolingCost + totalFobwithoutTooling,
        totalFobwithoutTooling
      )
    : percentOfTotalNotFixed (
        sectionToolingCost + totalFobwithoutTooling,
        totalFobwithoutTooling + otherAdjCost
      );

  return (
    <div style={{width: '100%'}}>
      <div
        className={`${s.scaleLine}`}
        style={{
          width: scaleWidth,
        }}
      >
        <div className={`${s.percent25}`} />
        <div className={`${s.percent25}`} />
        <div className={`${s.percent25}`} />
        <div className={`${s.percent25}`} />
      </div>
      <div
        style={{
          width: scaleWidth,
        }}
        className={`${s.values}`}
      >
        <p className={`${s.lineValue}`}>
          25%
        </p>
        <p className={`${s.lineValue}`}>
          50%
        </p>
        <p className={`${s.lineValue}`}>
          75%
        </p>
        <p className={`${s.lineValue}`}>
          100%
        </p>
      </div>
    </div>
  );
};

export default LinePercentScale;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/LinePercentScale/LinePercentScale.js